<template>
  <form class="step-one" @submit.prevent="signupUser">
    <p class="description">{{$t('signupflow.step-1.description')}}</p>
    <custom-input
      v-model="userInfo.user.name"
      id="nameInput"
      :inputType="'text'"
      :name="'name'"
      :label="$t('signupflow.step-1.input-1.label')"
      :placeholder="$t('signupflow.step-1.input-1.placeholder')"
      :focusInputField="true"
      boxed
    />
    <custom-input
      v-model="userInfo.user.username"
      id="emailInput"
      :inputType="'email'"
      :name="'email'"
      :label="$t('signupflow.step-1.input-2.label')"
      :placeholder="$t('signupflow.step-1.input-2.placeholder')"
      :supportingText="emailSupportingText"
      boxed
    />
    <custom-input
      v-model="userInfo.user.password"
      id="passwordInput"
      ref="passwordInput"
      :inputType="'password'"
      :name="'password'"
      :label="$t('signupflow.step-1.input-3.label')"
      :placeholder="$t('signupflow.step-1.input-3.placeholder')"
      :supportingText="passwordSupportingText"
      boxed
    />
    <checkbox lightLabel :label="''" :name="'terms'" :value="terms" v-model="terms" class="terms">
      <span class="text-muted text-small" v-html="$t('signupflow.step-1.terms')"></span>
    </checkbox>

    <button type="submit" class="btn-signup-flow" :disabled="!valid || loading">
      {{$t('signupflow.step-1.primary-btn')}} <span v-show="loading"><i class="fa-light fa-circle-notch fa-spin"></i></span>
    </button>

    <router-link :to="{ name: 'login' }" class="to-login">
      {{$t('signupflow.step-1.secondary-btn')}}
    </router-link>
  </form>
</template>

<script>
import appHelper from "@/assets/js/appHelper.js";
import Checkbox from "@/components/Checkbox";
export default {
  components: { Checkbox },
  data() {
    return {
      terms: false,
      passwordSupportingText: this.$t('signupflow.step-1.password-text'),
      emailSupportingText: "",
      loading: false,
      userInfo: {
        name: "",
        user: {
          username: "",
          password: "",
          name: "",
          phone: " "
        }
      },
      userExistsError: false
    };
  },
  props:{
    userRequestedSolution: {
      type: String,
      default: null
    },
    userRequestedPlan: {
      type: Number,
      default: null
    },
  },
  computed: {
    valid() {
      return (
        this.userInfo.user.name &&
        appHelper.emailRegex.test(this.userInfo.user.username) &&
        this.userInfo.user.password &&
        this.terms
      );
    }
  },
  methods: {
    signupUser() {
      this.loading = true;
      this.userExistsError = false;
      this.emailSupportingText = "";
      // Check if terms are checked
      // Do email validation

      // Do password validation
      if (!this.validatePassword(this.userInfo.user.password)) return (this.loading = false);
      // set name to organization name
      this.userInfo.name = this.userInfo.user.name + "s organization";

      this.$store
        .dispatch("signupFromFlow", {userInfo: this.userInfo, params:{ solution: this.userRequestedSolution, plan: this.userRequestedPlan}})
        .then(() => {
          // If signup success - login and receive token emit ('user-created')
          this.$store
            .dispatch("logIn", { email: this.userInfo.user.username, password: this.userInfo.user.password })
            .then(() => {
              this.loading = false;
              this.$emit("user-created", this.userInfo);
            });
        })
        .catch((e) => {
          this.loading = false;
          if (e.status == 400) {
            // If exists - Give message to go to login instead
            const baseUrl = appHelper.getBaseUrl();
            this.userExistsError = true;
            this.emailSupportingText = `${this.$t('signupflow.step-1.email-text')} <a href="${baseUrl}/login">${this.$t('signupflow.step-1.email-text-login')}</a>`;
          }
        });
    },

    validatePassword(password) {
      this.passwordSupportingText = "";
      if (password.length < 8) {
        this.passwordSupportingText =  this.$t('signupflow.step-1.password-text-error')
        return false;
      }
      return true;
    }
  },
  watch: {
    valid: {
      handler: function(val) {
        this.$emit("valid", val);
      }
    }
  }
};
</script>
<style lang="less">
.step-one {
  .terms {
    margin-top: 18px;
    font-weight: 500;
  }
}
#app .step-one .to-login {
  font-size: 12px;
  color: var(--text-grey-primary);
  text-decoration: underline;
  align-self: flex-end;
}
</style>
